import React, { lazy, Component } from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-24 bg-[#0a0a0a] text-white relative overflow-hidden" aria-label="El Sistema IMÁN" data-id="element-466">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[70%] h-[70%] bg-[#C9A961]/5 rounded-full blur-[150px] pointer-events-none" data-id="element-467" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-468">
        <div className="text-center mb-16" data-id="element-469">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-bold mb-6" data-id="element-470">
            El sistema <span className="text-[#C9A961]" data-id="element-471">IMÁN</span>
          </motion.h2>
        </div>

        {/* Image 3 - IMÁN Framework - Full width hero */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-6xl mx-auto mb-16" data-id="element-472">
          <div className="rounded-3xl overflow-hidden shadow-2xl border border-[#C9A961]/20" data-id="element-473">
            <img src="https://cdn.magicpatterns.com/uploads/wAxenUuUtSueEeRtPDU1iz/3-landing_iman_framework_1920x1080.png" alt="Gráfico explicativo del Sistema IMÁN Framework: Intención, Mensaje, Anclaje, Next Step" className="w-full h-auto" loading="lazy" data-id="element-474" />
          </div>
        </motion.div>

        {/* Framework Components - Matching the image layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-475">
          {[{
          letter: 'I',
          title: 'Intención',
          desc: '¿Qué quieres que ocurra al final?'
        }, {
          letter: 'M',
          title: 'Mensaje nuclear',
          desc: 'Una sola frase que sostiene todo.'
        }, {
          letter: 'Á',
          title: 'Anclaje emocional',
          desc: 'Por qué esto importa ahora.'
        }, {
          letter: 'N',
          title: 'Siguiente paso',
          desc: 'Acción concreta, responsable y fecha.'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black/40 backdrop-blur-sm p-6 rounded-xl border border-[#C9A961]/20 text-center hover:border-[#C9A961]/50 transition-colors" data-id="element-476">
              <div className="w-14 h-14 bg-[#C9A961] rounded-full flex items-center justify-center text-black font-bold text-2xl mx-auto mb-4 shadow-lg" data-id="element-477">
                {item.letter}
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-478">{item.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-479">
                {item.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center max-w-3xl mx-auto" data-id="element-480">
          <p className="text-lg text-gray-300 italic leading-relaxed" data-id="element-481">
            "Cuando falta una parte, tu mensaje se diluye.{' '}
            <span className="text-[#C9A961] font-bold not-italic" data-id="element-482">
              Cuando están las cuatro, tu comunicación se siente como confianza.
            </span>
            "
          </p>
        </motion.div>
      </div>
    </section>;
}